(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blfr"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var movimientoReducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function cada(lista, accion) {
      Array.prototype.forEach.call(lista, accion);
    }

    function fechaMadrid(texto) {
      var partes = String(texto || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
      if (!partes) return null;
      var supuesto = Date.UTC(Number(partes[1]), Number(partes[2]) - 1, Number(partes[3]), partes[4] ? Number(partes[4]) : 0, partes[5] ? Number(partes[5]) : 0);
      var desfase = 60;
      try {
        var formato = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
        var trozos = {};
        formato.formatToParts(new Date(supuesto)).forEach(function (trozo) { trozos[trozo.type] = trozo.value; });
        var local = Date.UTC(Number(trozos.year), Number(trozos.month) - 1, Number(trozos.day), Number(trozos.hour) % 24, Number(trozos.minute));
        desfase = Math.round((local - supuesto) / 60000);
      } catch (e) {}
      return new Date(supuesto - desfase * 60000);
    }

    function leer(clave) {
      try { return window.localStorage.getItem(clave); } catch (e) { return null; }
    }

    function guardar(clave, valor) {
      try { window.localStorage.setItem(clave, valor); } catch (e) {}
    }

    function iniciar(raiz) {
      if (!raiz || raiz.getAttribute('data-yume-bf-listo') === 'true') return;
      raiz.setAttribute('data-yume-bf-listo', 'true');
      var puedeAnimar = !movimientoReducido && typeof raiz.animate === 'function';
      var modo = raiz.getAttribute('data-modo') || 'auto';
      var editor = raiz.getAttribute('data-editor') === 'true';
      var inicio = fechaMadrid(raiz.getAttribute('data-inicio'));
      var fin = fechaMadrid(raiz.getAttribute('data-fin'));
      var capaConfeti = raiz.querySelector('[data-yume-bf-confeti]');
      var estilo = window.getComputedStyle(raiz);
      var oro = (estilo.getPropertyValue('--yume-bf-oro') || '#E3B04B').trim();
      var acento = (estilo.getPropertyValue('--yume-bf-acento') || '#C9805F').trim();

      function confeti(origen, cantidad) {
        if (!puedeAnimar || !capaConfeti || !origen) return;
        var caja = origen.getBoundingClientRect();
        var colores = [oro, acento, '#FFFFFF', '#FFF3C4', '#B8862D'];
        for (var i = 0; i < cantidad; i += 1) {
          var pieza = document.createElement('span');
          var estrella = i % 4 === 0;
          pieza.className = 'yume-bf-pieza' + (estrella ? ' yume-bf-pieza--estrella' : '');
          if (estrella) {
            pieza.textContent = '✦';
            pieza.style.color = oro;
          } else {
            pieza.style.background = colores[i % colores.length];
          }
          pieza.style.left = (caja.left + caja.width / 2 + (Math.random() - 0.5) * caja.width * 0.8) + 'px';
          pieza.style.top = (caja.top + caja.height / 2) + 'px';
          capaConfeti.appendChild(pieza);
          var angulo = -Math.PI * (0.05 + Math.random() * 0.9);
          var fuerza = 120 + Math.random() * 220;
          var dx = Math.cos(angulo) * fuerza;
          var dy = Math.sin(angulo) * fuerza;
          var giro = (Math.random() - 0.5) * 1000;
          var animacion = pieza.animate([
            { transform: 'translate(-50%, -50%) translate(0px, 0px) rotate(0deg) scale(0.4)', opacity: 1 },
            { transform: 'translate(-50%, -50%) translate(' + dx + 'px, ' + dy + 'px) rotate(' + (giro / 2) + 'deg) scale(1)', opacity: 1, offset: 0.4 },
            { transform: 'translate(-50%, -50%) translate(' + (dx * 1.3) + 'px, ' + (dy + 260) + 'px) rotate(' + giro + 'deg) scale(0.8)', opacity: 0 }
          ], { duration: 1200 + Math.random() * 700, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'forwards' });
          animacion.onfinish = (function (nodo) { return function () { if (nodo.parentNode) nodo.parentNode.removeChild(nodo); }; })(pieza);
        }
      }

      function calcularFase() {
        if (modo !== 'auto') return modo;
        var ahora = Date.now();
        if (inicio && ahora < inicio.getTime()) return 'teaser';
        if (fin && ahora >= fin.getTime()) return 'terminado';
        return 'activo';
      }

      var faseActual = null;
      function aplicarFase() {
        var fase = calcularFase();
        if (fase === faseActual) return fase;
        var anterior = faseActual;
        faseActual = fase;
        raiz.setAttribute('data-fase', fase);
        raiz.classList.toggle('yume-bf--oculta', fase === 'terminado' && raiz.getAttribute('data-al-terminar') === 'ocultar' && !editor);
        if (anterior === 'teaser' && fase === 'activo') {
          var portada = raiz.querySelector('.yume-bf-portada');
          confeti(portada, 90);
          prepararTapa();
        }
        return fase;
      }

      var celdas = {};
      cada(raiz.querySelectorAll('[data-yume-bf-u]'), function (celda) { celdas[celda.getAttribute('data-yume-bf-u')] = celda; });
      var dos = function (n) { return (n < 10 ? '0' : '') + n; };
      function pintarCelda(clave, valor) {
        var celda = celdas[clave];
        if (!celda || celda.textContent === valor) return;
        celda.textContent = valor;
        if (puedeAnimar) {
          celda.animate([
            { transform: 'translateY(-60%) rotateX(80deg)', opacity: 0 },
            { transform: 'translateY(0) rotateX(0deg)', opacity: 1 }
          ], { duration: 380, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
        }
      }

      function tic() {
        var fase = aplicarFase();
        var objetivo = fase === 'teaser' ? inicio : fase === 'activo' ? fin : null;
        if (!objetivo) return;
        var resto = Math.max(0, Math.floor((objetivo.getTime() - Date.now()) / 1000));
        pintarCelda('d', dos(Math.floor(resto / 86400)));
        pintarCelda('h', dos(Math.floor((resto % 86400) / 3600)));
        pintarCelda('m', dos(Math.floor((resto % 3600) / 60)));
        pintarCelda('s', dos(resto % 60));
      }

      var carta = raiz.querySelector('[data-yume-bf-carta]');
      var tapa = raiz.querySelector('[data-yume-bf-tapa]');
      var despues = raiz.querySelector('[data-yume-bf-despues]');
      var claveRasca = 'yume_bf_rascado_' + (raiz.closest('.shopify-section') ? raiz.closest('.shopify-section').id : 'bf');
      var rascado = leer(claveRasca) === 'si' && !editor;
      var contexto = tapa ? tapa.getContext('2d') : null;
      var escala = window.devicePixelRatio || 1;
      var movimientos = 0;
      var ultimo = null;

      function revelar(celebrar) {
        if (!tapa) return;
        rascado = true;
        if (!editor) guardar(claveRasca, 'si');
        if (despues) despues.hidden = false;
        if (celebrar && puedeAnimar) {
          var salida = tapa.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 450, fill: 'forwards' });
          salida.onfinish = function () { tapa.style.display = 'none'; };
          confeti(carta, 110);
          var premio = raiz.querySelector('.yume-bf-rasca__cifra');
          if (premio) {
            premio.animate([
              { transform: 'scale(0.6) rotate(-8deg)' },
              { transform: 'scale(1.25) rotate(4deg)', offset: 0.55 },
              { transform: 'scale(1) rotate(0deg)' }
            ], { duration: 800, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
          }
          if (navigator.vibrate) { try { navigator.vibrate([20, 40, 30, 40, 60]); } catch (e) {} }
        } else {
          tapa.style.display = 'none';
        }
      }

      function prepararTapa() {
        if (!tapa || !contexto || rascado) return;
        var caja = tapa.getBoundingClientRect();
        if (!caja.width) return;
        tapa.width = Math.round(caja.width * escala);
        tapa.height = Math.round(caja.height * escala);
        var ancho = tapa.width;
        var alto = tapa.height;
        contexto.globalCompositeOperation = 'source-over';
        var degradado = contexto.createLinearGradient(0, 0, ancho, alto);
        degradado.addColorStop(0, '#d9d4c7');
        degradado.addColorStop(0.35, '#f4efe2');
        degradado.addColorStop(0.5, '#bdb6a5');
        degradado.addColorStop(0.75, '#efe9da');
        degradado.addColorStop(1, '#a9a291');
        contexto.fillStyle = degradado;
        contexto.fillRect(0, 0, ancho, alto);
        contexto.fillStyle = 'rgba(120, 110, 90, 0.25)';
        contexto.font = Math.round(14 * escala) + 'px sans-serif';
        for (var y = 18 * escala; y < alto; y += 34 * escala) {
          for (var x = ((y / (34 * escala)) % 2) * 17 * escala; x < ancho; x += 34 * escala) {
            contexto.fillText('✦', x, y);
          }
        }
        contexto.fillStyle = '#3a342a';
        contexto.textAlign = 'center';
        contexto.textBaseline = 'middle';
        contexto.font = '800 ' + Math.round(Math.min(ancho / 10, 30 * escala)) + 'px sans-serif';
        contexto.fillText(tapa.getAttribute('data-texto') || '', ancho / 2, alto / 2);
        contexto.font = Math.round(Math.min(ancho / 14, 22 * escala)) + 'px sans-serif';
        contexto.fillText('☝️', ancho / 2, alto / 2 + Math.min(ancho / 8, 40 * escala));
      }

      function puntoDe(evento) {
        var caja = tapa.getBoundingClientRect();
        return { x: (evento.clientX - caja.left) * escala, y: (evento.clientY - caja.top) * escala };
      }

      function rascar(desde, hasta) {
        contexto.globalCompositeOperation = 'destination-out';
        contexto.lineCap = 'round';
        contexto.lineJoin = 'round';
        contexto.lineWidth = 46 * escala;
        contexto.beginPath();
        contexto.moveTo(desde.x, desde.y);
        contexto.lineTo(hasta.x, hasta.y);
        contexto.stroke();
        movimientos += 1;
        if (movimientos % 6 === 0) comprobar();
      }

      function comprobar() {
        var datos = contexto.getImageData(0, 0, tapa.width, tapa.height).data;
        var total = 0;
        var claros = 0;
        for (var i = 3; i < datos.length; i += 4 * 24) {
          total += 1;
          if (datos[i] === 0) claros += 1;
        }
        if (total && claros / total > 0.45) revelar(true);
      }

      if (tapa && contexto) {
        if (rascado) {
          revelar(false);
        } else {
          prepararTapa();
          window.addEventListener('resize', function () { if (!rascado && !ultimo) prepararTapa(); });
          tapa.addEventListener('pointerdown', function (evento) {
            if (rascado) return;
            if (faseActual === 'teaser') {
              var candado = raiz.querySelector('.yume-bf-rasca__candado');
              if (candado && puedeAnimar) {
                candado.animate([
                  { rotate: '0deg' }, { rotate: '-18deg', offset: 0.25 }, { rotate: '16deg', offset: 0.5 }, { rotate: '-8deg', offset: 0.75 }, { rotate: '0deg' }
                ], { duration: 600 });
              }
              return;
            }
            evento.preventDefault();
            if (tapa.setPointerCapture) { try { tapa.setPointerCapture(evento.pointerId); } catch (e) {} }
            ultimo = puntoDe(evento);
            rascar(ultimo, { x: ultimo.x + 0.1, y: ultimo.y + 0.1 });
          });
          tapa.addEventListener('pointermove', function (evento) {
            if (!ultimo || rascado) return;
            evento.preventDefault();
            var punto = puntoDe(evento);
            rascar(ultimo, punto);
            ultimo = punto;
          });
          var soltar = function () {
            if (!ultimo) return;
            ultimo = null;
            if (!rascado) comprobar();
          };
          tapa.addEventListener('pointerup', soltar);
          tapa.addEventListener('pointercancel', soltar);
        }
      }

      tic();
      window.setInterval(tic, 1000);

      if (!puedeAnimar) return;

      var pista = raiz.querySelector('[data-yume-bf-cinta]');
      if (pista) {
        var mitad = pista.scrollWidth / 2;
        pista.animate([
          { transform: 'translateX(0)' },
          { transform: 'translateX(-' + mitad + 'px)' }
        ], { duration: (Number(raiz.getAttribute('data-velocidad')) || 30) * 1000, iterations: Infinity, easing: 'linear' });
      }

      var cielo = raiz.querySelector('[data-yume-bf-cielo]');
      if (cielo) {
        var cuantas = Number(raiz.getAttribute('data-estrellas')) || 0;
        for (var i = 0; i < cuantas; i += 1) {
          var estrella = document.createElement('span');
          var tam = 1 + Math.random() * 2.2;
          estrella.className = 'yume-bf-estrella';
          estrella.style.width = tam + 'px';
          estrella.style.height = tam + 'px';
          estrella.style.left = (Math.random() * 100) + '%';
          estrella.style.top = (Math.random() * 100) + '%';
          cielo.appendChild(estrella);
          estrella.animate([
            { opacity: 0.15 }, { opacity: 1 }, { opacity: 0.15 }
          ], { duration: 1800 + Math.random() * 3200, delay: Math.random() * 3000, iterations: Infinity, easing: 'ease-in-out' });
        }
        var luna = cielo.querySelector('.yume-bf-luna');
        if (luna) {
          luna.animate([
            { translate: '0 0' }, { translate: '0 -10px' }, { translate: '0 0' }
          ], { duration: 7000, iterations: Infinity, easing: 'ease-in-out' });
        }
        if (raiz.getAttribute('data-fugaces') === 'true') {
          var lanzarFugaz = function () {
            if (!document.hidden) {
              var fugaz = document.createElement('span');
              fugaz.className = 'yume-bf-fugaz';
              fugaz.style.left = (10 + Math.random() * 70) + '%';
              fugaz.style.top = (Math.random() * 40) + '%';
              cielo.appendChild(fugaz);
              var vuelo = fugaz.animate([
                { transform: 'rotate(25deg) translateX(0)', opacity: 0 },
                { transform: 'rotate(25deg) translateX(120px)', opacity: 1, offset: 0.2 },
                { transform: 'rotate(25deg) translateX(420px)', opacity: 0 }
              ], { duration: 1100, easing: 'ease-out', fill: 'forwards' });
              vuelo.onfinish = function () { if (fugaz.parentNode) fugaz.parentNode.removeChild(fugaz); };
            }
            window.setTimeout(lanzarFugaz, 3500 + Math.random() * 5000);
          };
          window.setTimeout(lanzarFugaz, 1500);
        }
      }

      cada(raiz.querySelectorAll('[data-yume-bf-oro]'), function (texto) {
        texto.animate([
          { backgroundPosition: '0% 50%' }, { backgroundPosition: '220% 50%' }
        ], { duration: 4000, iterations: Infinity, easing: 'linear' });
      });

      cada(raiz.querySelectorAll('.yume-bf-boton__brillo span'), function (brillo, indice) {
        brillo.animate([
          { transform: 'translateX(0) skewX(-20deg)', offset: 0 },
          { transform: 'translateX(480%) skewX(-20deg)', offset: 0.35 },
          { transform: 'translateX(480%) skewX(-20deg)', offset: 1 }
        ], { duration: 2800, delay: indice * 700, iterations: Infinity, easing: 'ease-in-out' });
      });

      cada(raiz.querySelectorAll('.yume-bf-boton'), function (boton) {
        boton.animate([
          { scale: '1' }, { scale: '1.04' }, { scale: '1' }
        ], { duration: 2200, iterations: Infinity, easing: 'ease-in-out' });
      });

      cada(raiz.querySelectorAll('.yume-bf-oferta__aro span'), function (aro) {
        aro.animate([
          { transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }
        ], { duration: 3500, iterations: Infinity, easing: 'linear' });
      });

      cada(raiz.querySelectorAll('.yume-bf-oferta__sello'), function (sello, indice) {
        sello.animate([
          { rotate: '-8deg', scale: '1' },
          { rotate: '8deg', scale: '1.08', offset: 0.5 },
          { rotate: '-8deg', scale: '1' }
        ], { duration: 2600, delay: indice * 300, iterations: Infinity, easing: 'ease-in-out' });
      });

      var punto = raiz.querySelector('.yume-bf-unidades__punto');
      if (punto) {
        punto.animate([
          { scale: '1', opacity: 1 }, { scale: '1.7', opacity: 0.4 }, { scale: '1', opacity: 1 }
        ], { duration: 1100, iterations: Infinity, easing: 'ease-in-out' });
      }

      if (carta && faseActual === 'activo' && !rascado) {
        carta.animate([
          { rotate: '0deg' }, { rotate: '0deg', offset: 0.75 }, { rotate: '-2deg', offset: 0.82 }, { rotate: '2deg', offset: 0.89 }, { rotate: '0deg', offset: 0.96 }, { rotate: '0deg' }
        ], { duration: 3600, iterations: Infinity, easing: 'ease-in-out' });
      }
    }

    function iniciarTodas(contenedor) {
      cada((contenedor || document).querySelectorAll('[data-yume-bf]'), iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciarTodas(document); });
    } else {
      iniciarTodas(document);
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodas(evento.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["encalmo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var movimientoReducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var modoEditor = !!(window.Shopify && window.Shopify.designMode);
    var claveAnuncio = 'nuvia-cab-anuncio-cerrado';

    function cadaElemento(lista, accion) {
      Array.prototype.forEach.call(lista, accion);
    }

    function fijar(elemento, propiedad, valor) {
      elemento.style.setProperty(propiedad, valor, 'important');
    }

    function leerSesion(clave) {
      try {
        return window.sessionStorage.getItem(clave);
      } catch (error) {
        return null;
      }
    }

    function guardarSesion(clave, valor) {
      try {
        window.sessionStorage.setItem(clave, valor);
      } catch (error) {
        return;
      }
    }

    function iniciar(raiz) {
      if (!raiz || raiz.dataset.nuviaLista === 'true') return;
      raiz.dataset.nuviaLista = 'true';

      var seccion = raiz.closest('.shopify-section') || raiz.parentElement;
      var anuncio = raiz.querySelector('[data-nuvia-anuncio]');
      var barra = raiz.querySelector('[data-nuvia-barra]');
      var cajon = raiz.querySelector('[data-nuvia-cajon]');
      var botonMenu = raiz.querySelector('[data-nuvia-abrir-menu]');
      var buscador = raiz.querySelector('[data-nuvia-buscador]');
      var campoBusqueda = raiz.querySelector('[data-nuvia-campo-busqueda]');
      var lista = raiz.querySelector('[data-nuvia-lista]');
      var indicador = raiz.querySelector('[data-nuvia-indicador]');
      var enlaces = raiz.querySelectorAll('[data-nuvia-enlace]');
      var progreso = raiz.querySelector('[data-nuvia-progreso]');
      var modoFijo = raiz.dataset.modoFijo;
      var limpiezas = [];
      var ultimoScroll = window.pageYOffset;
      var oculta = false;
      var menuAbierto = false;
      var busquedaAbierta = false;
      var enlaceActivo = null;
      var ultimoFoco = null;

      function escuchar(objetivo, evento, funcion, opciones) {
        objetivo.addEventListener(evento, funcion, opciones);
        limpiezas.push(function () { objetivo.removeEventListener(evento, funcion, opciones); });
      }

      function altoAnuncio() {
        return anuncio && anuncio.offsetParent !== null ? anuncio.offsetHeight : 0;
      }

      function colocar() {
        if (modoFijo === 'no') return;
        var desplazamiento = altoAnuncio();
        if (oculta) desplazamiento += barra.offsetHeight + 6;
        fijar(seccion, 'top', (-desplazamiento) + 'px');
        document.documentElement.style.setProperty('--header-height', barra.offsetHeight + 'px');
      }

      function alScroll() {
        var actual = window.pageYOffset;
        raiz.classList.toggle('nuvia-cab--compacta', actual > 12);

        if (modoFijo === 'al_subir' && !menuAbierto && !busquedaAbierta) {
          var umbral = altoAnuncio() + barra.offsetHeight + 80;
          var debeOcultar = actual > ultimoScroll && actual > umbral;
          var debeMostrar = actual < ultimoScroll - 4 || actual <= umbral;
          if (debeOcultar && !oculta) {
            oculta = true;
            colocar();
          } else if (debeMostrar && oculta) {
            oculta = false;
            colocar();
          }
        }

        if (progreso) {
          var total = document.documentElement.scrollHeight - window.innerHeight;
          var valor = total > 0 ? Math.min(1, Math.max(0, actual / total)) : 0;
          fijar(progreso, '--nuvia-cab-progreso', valor.toFixed(4));
        }

        ultimoScroll = actual;
      }

      var pendiente = false;
      escuchar(window, 'scroll', function () {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(function () {
          alScroll();
          pendiente = false;
        });
      }, { passive: true });

      function iniciarAnuncio() {
        if (!anuncio) return;
        var cerrar = raiz.querySelector('[data-nuvia-anuncio-cerrar]');
        if (cerrar) {
          if (!modoEditor && leerSesion(claveAnuncio) === '1') anuncio.hidden = true;
          escuchar(cerrar, 'click', function () {
            anuncio.hidden = true;
            guardarSesion(claveAnuncio, '1');
            colocar();
          });
        }

        var elementos = anuncio.querySelectorAll('[data-nuvia-anuncio-item]');
        if (elementos.length < 2) return;
        var indice = 0;
        var pausado = false;
        var segundos = parseInt(raiz.dataset.rotacion, 10) || 5;

        function mostrar(nuevo) {
          cadaElemento(elementos, function (elemento, posicion) {
            var activo = posicion === nuevo;
            elemento.classList.toggle('nuvia-cab-anuncio-item--activo', activo);
            if (activo) {
              elemento.removeAttribute('aria-hidden');
            } else {
              elemento.setAttribute('aria-hidden', 'true');
            }
          });
          indice = nuevo;
        }

        var intervalo = window.setInterval(function () {
          if (!pausado) mostrar((indice + 1) % elementos.length);
        }, segundos * 1000);
        limpiezas.push(function () { window.clearInterval(intervalo); });

        escuchar(anuncio, 'mouseenter', function () { pausado = true; });
        escuchar(anuncio, 'mouseleave', function () { pausado = false; });
        escuchar(anuncio, 'focusin', function () { pausado = true; });
        escuchar(anuncio, 'focusout', function () { pausado = false; });
        escuchar(document, 'shopify:block:select', function (evento) {
          cadaElemento(elementos, function (elemento, posicion) {
            if (elemento === evento.target) {
              pausado = true;
              mostrar(posicion);
            }
          });
        });
        escuchar(document, 'shopify:block:deselect', function () { pausado = false; });
      }

      function moverIndicador(enlace) {
        if (!indicador || !lista) return;
        if (!enlace) {
          indicador.classList.remove('nuvia-cab-indicador--visible');
          cadaElemento(enlaces, function (otro) { otro.classList.remove('nuvia-cab-enlace--indicado'); });
          return;
        }
        var cajaLista = lista.getBoundingClientRect();
        var cajaEnlace = enlace.getBoundingClientRect();
        if (!cajaEnlace.width) return;
        fijar(raiz, '--nuvia-cab-x', (cajaEnlace.left - cajaLista.left) + 'px');
        fijar(raiz, '--nuvia-cab-w', cajaEnlace.width + 'px');
        indicador.classList.add('nuvia-cab-indicador--visible');
        cadaElemento(enlaces, function (otro) {
          otro.classList.toggle('nuvia-cab-enlace--indicado', otro === enlace);
        });
      }

      function enlaceInicial() {
        var encontrado = null;
        cadaElemento(enlaces, function (enlace) {
          if (!encontrado && (enlace.classList.contains('nuvia-cab-enlace--actual') || enlace.getAttribute('aria-current') === 'page')) {
            encontrado = enlace;
          }
        });
        return encontrado;
      }

      function iniciarIndicador() {
        if (!indicador || !lista || !enlaces.length) return;
        lista.classList.add('nuvia-cab-lista--activa');
        enlaceActivo = enlaceInicial();
        cadaElemento(enlaces, function (enlace) {
          escuchar(enlace, 'mouseenter', function () { moverIndicador(enlace); });
          escuchar(enlace, 'focus', function () { moverIndicador(enlace); });
        });
        escuchar(lista, 'mouseleave', function () { moverIndicador(enlaceActivo); });
        escuchar(window, 'resize', function () { moverIndicador(enlaceActivo); });
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () { moverIndicador(enlaceActivo); });
        }
        moverIndicador(enlaceActivo);
      }

      function destinoDeEnlace(enlace) {
        var href = enlace.getAttribute('href') || '';
        if (href.indexOf('#') === -1) return null;
        var url;
        try {
          url = new URL(enlace.href, window.location.href);
        } catch (error) {
          return null;
        }
        if (url.pathname !== window.location.pathname || !url.hash || url.hash.length < 2) return null;
        var id = decodeURIComponent(url.hash.slice(1));
        return document.getElementById(id);
      }

      function desplazarA(destino) {
        var margen = barra.offsetHeight + 12;
        var posicion = destino.getBoundingClientRect().top + window.pageYOffset - margen;
        window.scrollTo({ top: posicion, behavior: movimientoReducido ? 'auto' : 'smooth' });
      }

      function iniciarAnclas() {
        var todos = raiz.querySelectorAll('[data-nuvia-enlace], [data-nuvia-enlace-cajon]');
        var observables = [];
        cadaElemento(todos, function (enlace) {
          var destino = destinoDeEnlace(enlace);
          if (!destino) return;
          escuchar(enlace, 'click', function (evento) {
            evento.preventDefault();
            cerrarMenu(false);
            window.setTimeout(function () { desplazarA(destino); }, 10);
            if (window.history && window.history.replaceState) {
              window.history.replaceState(null, '', '#' + destino.id);
            }
          });
          if (enlace.hasAttribute('data-nuvia-enlace')) observables.push({ enlace: enlace, destino: destino });
        });

        if (raiz.dataset.espia !== 'true' || !observables.length || !('IntersectionObserver' in window)) return;
        var observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (!entrada.isIntersecting) return;
            observables.forEach(function (par) {
              if (par.destino === entrada.target) {
                enlaceActivo = par.enlace;
                if (!lista.matches(':hover')) moverIndicador(enlaceActivo);
              }
            });
          });
        }, { rootMargin: '-40% 0px -55% 0px' });
        observables.forEach(function (par) { observador.observe(par.destino); });
        limpiezas.push(function () { observador.disconnect(); });
      }

      function abrirMenu() {
        if (!cajon || menuAbierto) return;
        menuAbierto = true;
        ultimoFoco = document.activeElement;
        oculta = false;
        colocar();
        fijar(raiz, '--nuvia-cab-alto-barra', Math.max(0, barra.getBoundingClientRect().bottom) + 'px');
        cajon.hidden = false;
        raiz.classList.add('nuvia-cab--menu-abierto');
        botonMenu.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            cajon.classList.add('nuvia-cab-cajon--abierto');
          });
        });
        var primero = cajon.querySelector('a, summary, button');
        if (primero) window.setTimeout(function () { primero.focus({ preventScroll: true }); }, 350);
      }

      function cerrarMenu(devolverFoco) {
        if (!cajon || !menuAbierto) return;
        menuAbierto = false;
        cajon.classList.remove('nuvia-cab-cajon--abierto');
        raiz.classList.remove('nuvia-cab--menu-abierto');
        botonMenu.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        window.setTimeout(function () {
          if (!menuAbierto) cajon.hidden = true;
        }, movimientoReducido ? 0 : 700);
        if (devolverFoco !== false && ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
      }

      function abrirBusqueda() {
        if (!buscador) return;
        if (menuAbierto) cerrarMenu(false);
        busquedaAbierta = true;
        ultimoFoco = document.activeElement;
        buscador.hidden = false;
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            buscador.classList.add('nuvia-cab-buscador--abierto');
          });
        });
        if (campoBusqueda) window.setTimeout(function () { campoBusqueda.focus(); }, 120);
      }

      function cerrarBusqueda() {
        if (!buscador || !busquedaAbierta) return;
        busquedaAbierta = false;
        buscador.classList.remove('nuvia-cab-buscador--abierto');
        document.body.style.overflow = '';
        window.setTimeout(function () {
          if (!busquedaAbierta) buscador.hidden = true;
        }, movimientoReducido ? 0 : 550);
        if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
      }

      if (botonMenu) {
        escuchar(botonMenu, 'click', function () {
          if (menuAbierto) {
            cerrarMenu();
          } else {
            abrirMenu();
          }
        });
      }

      if (cajon) {
        cadaElemento(cajon.querySelectorAll('[data-nuvia-enlace-cajon]'), function (enlace) {
          if (destinoDeEnlace(enlace)) return;
          escuchar(enlace, 'click', function () { cerrarMenu(false); });
        });
      }

      cadaElemento(raiz.querySelectorAll('[data-nuvia-abrir-busqueda]'), function (boton) {
        escuchar(boton, 'click', abrirBusqueda);
      });
      cadaElemento(raiz.querySelectorAll('[data-nuvia-cerrar-busqueda]'), function (boton) {
        escuchar(boton, 'click', cerrarBusqueda);
      });

      escuchar(document, 'keydown', function (evento) {
        if (evento.key !== 'Escape') return;
        if (busquedaAbierta) cerrarBusqueda();
        if (menuAbierto) cerrarMenu();
      });

      escuchar(window, 'resize', function () {
        if (menuAbierto && window.innerWidth >= 990) cerrarMenu(false);
        colocar();
      });

      var burbuja = raiz.querySelector('#cart-icon-bubble');
      if (burbuja && 'MutationObserver' in window) {
        var observadorCarrito = new MutationObserver(function () {
          burbuja.classList.remove('nuvia-cab-carrito--salto');
          void burbuja.offsetWidth;
          burbuja.classList.add('nuvia-cab-carrito--salto');
        });
        observadorCarrito.observe(burbuja, { childList: true, subtree: true, characterData: true });
        limpiezas.push(function () { observadorCarrito.disconnect(); });
        escuchar(burbuja, 'animationend', function () { burbuja.classList.remove('nuvia-cab-carrito--salto'); });
      }

      iniciarAnuncio();
      iniciarIndicador();
      iniciarAnclas();
      colocar();
      alScroll();

      raiz._nuviaDestruir = function () {
        limpiezas.forEach(function (limpiar) { limpiar(); });
        document.body.style.overflow = '';
        if (seccion) seccion.style.removeProperty('top');
      };
    }

    function iniciarTodas(contenedor) {
      cadaElemento(contenedor.querySelectorAll('[data-nuvia-cabecera]'), iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciarTodas(document); });
    } else {
      iniciarTodas(document);
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodas(evento.target);
    });

    document.addEventListener('shopify:section:unload', function (evento) {
      cadaElemento(evento.target.querySelectorAll('[data-nuvia-cabecera]'), function (raiz) {
        if (raiz._nuviaDestruir) raiz._nuviaDestruir();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lanalmo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var movimientoReducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function cada(lista, accion) {
      Array.prototype.forEach.call(lista, accion);
    }

    function iniciar(raiz) {
      if (!raiz || raiz.getAttribute('data-yume-in-listo') === 'true') return;
      raiz.setAttribute('data-yume-in-listo', 'true');
      var editor = !!(window.Shopify && window.Shopify.designMode);
      var puedeAnimar = !movimientoReducido && typeof raiz.animate === 'function';

      var hero = raiz.querySelector('[data-yume-in-hero]');
      var modo = raiz.getAttribute('data-modo') || 'automatico';
      var reloj = raiz.querySelector('[data-yume-in-reloj]');
      var relojIcono = raiz.querySelector('[data-yume-in-reloj-icono]');
      var minutosDe = function (texto, respaldo) {
        var partes = String(texto || '').match(/(\d{1,2}):(\d{2})/);
        return partes ? Number(partes[1]) * 60 + Number(partes[2]) : respaldo;
      };
      var minutoNoche = minutosDe(raiz.getAttribute('data-hora-noche'), 23 * 60 + 47);
      var minutoDia = minutosDe(raiz.getAttribute('data-hora-dia'), 7 * 60 + 30);
      if (minutoDia <= minutoNoche) minutoDia += 24 * 60;
      var limitar = function (valor) { return Math.min(Math.max(valor, 0), 1); };
      var pintarCielo = function (p) {
        var alba = limitar(1 - Math.abs(p - 0.5) / 0.3);
        raiz.style.setProperty('--yume-in-p', p.toFixed(3));
        raiz.style.setProperty('--yume-in-alba', alba.toFixed(3));
        raiz.style.setProperty('--yume-in-dia', limitar((p - 0.55) / 0.35).toFixed(3));
        raiz.style.setProperty('--yume-in-t1', limitar(1 - p / 0.3).toFixed(3));
        raiz.style.setProperty('--yume-in-t2', limitar(1 - Math.abs(p - 0.5) / 0.17).toFixed(3));
        raiz.style.setProperty('--yume-in-t3', limitar((p - 0.68) / 0.2).toFixed(3));
        if (reloj) {
          var minuto = Math.round(minutoNoche + (minutoDia - minutoNoche) * p) % (24 * 60);
          var hora = Math.floor(minuto / 60);
          reloj.textContent = (hora < 10 ? '0' : '') + hora + ':' + (minuto % 60 < 10 ? '0' : '') + (minuto % 60);
          if (relojIcono) relojIcono.textContent = p < 0.4 ? '\u263E' : p < 0.7 ? '\u2600\uFE0E' : '\u2600';
        }
      };
      if (!hero || movimientoReducido) {
        pintarCielo(1);
      } else if (modo === 'fijo') {
        pintarCielo(0);
      }
      if (hero && modo === 'automatico' && !movimientoReducido) {
        var duracion = (Number(raiz.getAttribute('data-duracion')) || 8) * 1000;
        var repetir = raiz.getAttribute('data-repetir') === 'true';
        var pausa = (Number(raiz.getAttribute('data-pausa')) || 4) * 1000;
        var inicioAuto = null;
        var haciaDia = true;
        pintarCielo(0);
        var animarAmanecer = function (tiempo) {
          if (inicioAuto === null) inicioAuto = tiempo;
          var avance = limitar((tiempo - inicioAuto) / duracion);
          var suave = avance < 0.5 ? 2 * avance * avance : 1 - Math.pow(-2 * avance + 2, 2) / 2;
          pintarCielo(haciaDia ? suave : 1 - suave);
          if (avance < 1) {
            window.requestAnimationFrame(animarAmanecer);
          } else if (repetir) {
            window.setTimeout(function () {
              haciaDia = !haciaDia;
              inicioAuto = null;
              window.requestAnimationFrame(animarAmanecer);
            }, haciaDia ? pausa : pausa / 2);
          }
        };
        var arrancar = function () { window.setTimeout(function () { window.requestAnimationFrame(animarAmanecer); }, 900); };
        if ('IntersectionObserver' in window) {
          var vistoHero = new IntersectionObserver(function (entradas) {
            entradas.forEach(function (entrada) {
              if (!entrada.isIntersecting) return;
              vistoHero.disconnect();
              arrancar();
            });
          }, { threshold: 0.3 });
          vistoHero.observe(hero);
        } else {
          arrancar();
        }
      }
      if (hero && raiz.classList.contains('yume-in--efecto')) {
        if (movimientoReducido) {
          raiz.classList.remove('yume-in--efecto');
        } else {
          var pendiente = false;
          var actualizar = function () {
            pendiente = false;
            var caja = hero.getBoundingClientRect();
            var recorrido = caja.height - window.innerHeight;
            var progreso = recorrido > 0 ? Math.min(Math.max(-caja.top / recorrido, 0), 1) : 0;
            pintarCielo(progreso);
          };
          var pedir = function () {
            if (pendiente) return;
            pendiente = true;
            window.requestAnimationFrame(actualizar);
          };
          window.addEventListener('scroll', pedir, { passive: true });
          window.addEventListener('resize', pedir);
          actualizar();
        }
      }

      var estrellas = raiz.querySelector('[data-yume-in-estrellas]');
      if (estrellas) {
        for (var i = 0; i < 60; i += 1) {
          var estrella = document.createElement('span');
          var tam = 1 + Math.random() * 2;
          estrella.className = 'yume-in-estrella';
          estrella.style.width = tam + 'px';
          estrella.style.height = tam + 'px';
          estrella.style.left = (Math.random() * 100) + '%';
          estrella.style.top = (Math.random() * 100) + '%';
          estrellas.appendChild(estrella);
          if (puedeAnimar) {
            estrella.animate([{ opacity: 0.2 }, { opacity: 1 }, { opacity: 0.2 }], { duration: 1800 + Math.random() * 3000, delay: Math.random() * 2500, iterations: Infinity, easing: 'ease-in-out' });
          }
        }
      }

      var pista = raiz.querySelector('[data-yume-in-cinta]');
      if (pista && puedeAnimar) {
        pista.animate([
          { transform: 'translateX(0)' },
          { transform: 'translateX(-' + (pista.scrollWidth / 2) + 'px)' }
        ], { duration: 32000, iterations: Infinity, easing: 'linear' });
      }

      if (puedeAnimar) {
        var rayos = raiz.querySelector('[data-yume-in-rayos]');
        if (rayos) rayos.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], { duration: 60000, iterations: Infinity, easing: 'linear' });
        cada(raiz.querySelectorAll('.yume-in-hero__nube'), function (nube, indice) {
          nube.animate([{ translate: '0 0' }, { translate: (indice % 2 ? '-' : '') + '40px 0' }, { translate: '0 0' }], { duration: 18000 + indice * 5000, iterations: Infinity, easing: 'ease-in-out' });
        });
        cada(raiz.querySelectorAll('.yume-in-hero__chip'), function (chip, indice) {
          chip.animate([{ translate: '0 0' }, { translate: '0 -6px' }, { translate: '0 0' }], { duration: 3200 + indice * 600, iterations: Infinity, easing: 'ease-in-out' });
        });
        cada(raiz.querySelectorAll('.yume-in-destacado__imagen'), function (imagen) {
          imagen.animate([{ translate: '0 0', rotate: '0deg' }, { translate: '0 -10px', rotate: '-1deg' }, { translate: '0 0', rotate: '0deg' }], { duration: 6000, iterations: Infinity, easing: 'ease-in-out' });
        });
        cada(raiz.querySelectorAll('.yume-in-manifiesto__luna'), function (luna) {
          luna.animate([{ scale: '1', opacity: 0.8 }, { scale: '1.15', opacity: 1 }, { scale: '1', opacity: 0.8 }], { duration: 7000, iterations: Infinity, easing: 'ease-in-out' });
        });
      }

      var revelar = raiz.querySelectorAll('.yume-in-revelar');
      if ('IntersectionObserver' in window) {
        if (puedeAnimar && !editor) raiz.classList.add('yume-in--animado');
        var observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (!entrada.isIntersecting) return;
            observador.unobserve(entrada.target);
            entrada.target.classList.add('yume-in-visible');
            var numero = entrada.target.querySelector('[data-yume-in-contar]');
            if (numero && puedeAnimar) {
              var final = parseFloat(String(numero.getAttribute('data-yume-in-contar')).replace(',', '.'));
              if (isNaN(final)) return;
              var decimales = (String(numero.getAttribute('data-yume-in-contar')).split(/[.,]/)[1] || '').length;
              var inicio = null;
              var paso = function (tiempo) {
                if (inicio === null) inicio = tiempo;
                var avance = Math.min((tiempo - inicio) / 1400, 1);
                var suave = 1 - Math.pow(1 - avance, 3);
                numero.textContent = (final * suave).toFixed(decimales).replace('.', ',');
                if (avance < 1) window.requestAnimationFrame(paso);
              };
              window.requestAnimationFrame(paso);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
        cada(revelar, function (elemento) { observador.observe(elemento); });
      }

      var quiz = raiz.querySelector('[data-yume-in-quiz]');
      if (quiz) {
        var opciones = quiz.querySelectorAll('[data-yume-in-opcion]');
        var resultado = quiz.querySelector('[data-yume-in-resultado]');
        cada(opciones, function (opcion) {
          opcion.addEventListener('click', function () {
            var valor = opcion.getAttribute('data-yume-in-opcion');
            cada(opciones, function (otra) { otra.setAttribute('aria-checked', otra === opcion ? 'true' : 'false'); });
            if (!resultado) return;
            var estabaOculto = resultado.hidden;
            resultado.hidden = false;
            cada(resultado.querySelectorAll('[data-yume-in-respuesta]'), function (respuesta) {
              respuesta.hidden = respuesta.getAttribute('data-yume-in-respuesta') !== valor;
            });
            if (puedeAnimar) {
              resultado.animate([
                { opacity: 0, transform: 'translateY(16px) scale(0.98)' },
                { opacity: 1, transform: 'translateY(0) scale(1)' }
              ], { duration: 450, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
              opcion.animate([{ scale: '1' }, { scale: '0.96' }, { scale: '1.02' }, { scale: '1' }], { duration: 420, easing: 'ease-out' });
            }
            if (estabaOculto) {
              var caja = resultado.getBoundingClientRect();
              if (caja.bottom > window.innerHeight) resultado.scrollIntoView({ behavior: movimientoReducido ? 'auto' : 'smooth', block: 'center' });
            }
          });
        });
      }
    }

    function iniciarTodas(contenedor) {
      cada((contenedor || document).querySelectorAll('[data-yume-in]'), iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciarTodas(document); });
    } else {
      iniciarTodas(document);
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodas(evento.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mai"]) return;
  try {
    
  (function () {
    var MONTO = '{' + '{amount}' + '}';

    function cada(lista, accion) {
      Array.prototype.forEach.call(lista, accion);
    }

    function formatearDinero(centimos, formato) {
      var valor = Math.round(Number(centimos) || 0);
      var plantilla = formato || MONTO;
      var patron = /\{\{\s*(\w+)\s*\}\}/;
      function separar(numero, decimales, miles, coma) {
        var fijo = (numero / 100).toFixed(decimales);
        var partes = fijo.split('.');
        var enteros = partes[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + miles);
        return partes[1] ? enteros + coma + partes[1] : enteros;
      }
      var coincidencia = plantilla.match(patron);
      var tipo = coincidencia ? coincidencia[1] : 'amount';
      var texto;
      switch (tipo) {
        case 'amount_no_decimals':
          texto = separar(valor, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          texto = separar(valor, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          texto = separar(valor, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          texto = separar(valor, 2, "'", '.');
          break;
        case 'amount_with_space_separator':
          texto = separar(valor, 2, ' ', ',');
          break;
        default:
          texto = separar(valor, 2, ',', '.');
      }
      return plantilla.replace(patron, texto);
    }

    function formatoTienda(raiz) {
      var con = raiz && raiz.closest ? raiz.closest('[data-formato-dinero]') : null;
      if (!con) con = document.querySelector('[data-formato-dinero]');
      return con ? con.getAttribute('data-formato-dinero') : MONTO;
    }

    function varianteActual(raiz) {
      var info = raiz.closest('product-info') || document;
      var entrada = info.querySelector('form[id^="product-form-"] input[name="id"]');
      if (entrada && entrada.value) return Number(entrada.value);
      var packs = raiz.getAttribute('data-variante');
      return packs ? Number(packs) : null;
    }

    function registrar(evento, variante, cantidad, precio, raiz) {
      if (!raiz || raiz.getAttribute('data-yume-tracking') !== 'true') return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: evento,
        variant_id: variante,
        quantity: cantidad,
        value: (precio * cantidad) / 100,
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      });
    }

    function anadirAlCarrito(variante, cantidad, origen) {
      var carrito = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var rutas = window.routes || {};
      var urlAnadir = rutas.cart_add_url || '/cart/add';
      var configuracion = typeof window.fetchConfig === 'function'
        ? window.fetchConfig('javascript')
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
      var cuerpo = { items: [{ id: variante, quantity: cantidad }] };
      if (carrito && typeof carrito.getSectionsToRender === 'function') {
        cuerpo.sections = carrito.getSectionsToRender().map(function (seccion) { return seccion.id; });
        cuerpo.sections_url = window.location.pathname;
      }
      configuracion.body = JSON.stringify(cuerpo);
      return fetch(urlAnadir, configuracion)
        .then(function (respuesta) { return respuesta.json(); })
        .then(function (estado) {
          if (estado.status) {
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartError, {
                source: origen,
                productVariantId: variante,
                errors: estado.errors || estado.description,
                message: estado.message
              });
            }
            return estado;
          }
          if (!carrito) {
            window.location.href = rutas.cart_url || '/cart';
            return estado;
          }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: origen, productVariantId: variante, cartData: estado });
          }
          carrito.renderContents(estado);
          carrito.classList.remove('is-empty');
          var interior = carrito.querySelector('.drawer__inner');
          if (interior) interior.classList.remove('is-empty');
          return estado;
        });
    }

    function actualizarPrecios(variante) {
      cada(document.querySelectorAll('[data-yume-precio]'), function (raiz) {
        var precio = raiz.querySelector('[data-precio]');
        var anterior = raiz.querySelector('[data-anterior]');
        var ahorro = raiz.querySelector('[data-ahorro]');
        var uso = raiz.querySelector('[data-uso]');
        var formato = formatoTienda(raiz);
        if (!variante) return;
        if (precio) precio.textContent = formatearDinero(variante.price, formato);
        var hay = variante.compare_at_price && variante.compare_at_price > variante.price;
        if (anterior) {
          anterior.hidden = !hay;
          if (hay) anterior.textContent = formatearDinero(variante.compare_at_price, formato);
        }
        if (ahorro) {
          ahorro.hidden = !hay || !raiz.getAttribute('data-texto-ahorro');
          if (hay) {
            var diferencia = variante.compare_at_price - variante.price;
            var valor = raiz.getAttribute('data-formato') === 'importe'
              ? formatearDinero(diferencia, formato)
              : Math.floor((diferencia * 100) / variante.compare_at_price) + '%';
            ahorro.textContent = (raiz.getAttribute('data-texto-ahorro') || '').replace('[[valor]]', valor);
          }
        }
        var usos = Number(raiz.getAttribute('data-usos')) || 0;
        if (uso && usos > 0) {
          uso.textContent = (raiz.getAttribute('data-texto-uso') || '').replace('[[valor]]', formatearDinero(Math.floor(variante.price / usos), formato));
        }
      });
    }

    function iniciarPacks(raiz) {
      if (raiz.getAttribute('data-yume-listo') === 'true') return;
      raiz.setAttribute('data-yume-listo', 'true');
      var tarjetas = raiz.querySelectorAll('[data-yume-pack]');
      var boton = raiz.querySelector('[data-yume-packs-boton]');
      var textoBoton = raiz.querySelector('[data-texto]');
      var error = raiz.querySelector('[data-error]');
      var formato = formatoTienda(raiz);
      var disponible = raiz.getAttribute('data-disponible') === 'true';

      function seleccionada() {
        var activa = null;
        cada(tarjetas, function (tarjeta) {
          var radio = tarjeta.querySelector('input[type="radio"]');
          if (radio && radio.checked) activa = tarjeta;
        });
        return activa || tarjetas[0];
      }

      function calcular(tarjeta) {
        var base = Number(raiz.getAttribute('data-precio-base')) || 0;
        var unidades = Number(tarjeta.getAttribute('data-unidades')) || 1;
        var descuento = Number(tarjeta.getAttribute('data-descuento')) || 0;
        var totalBase = base * unidades;
        var rebaja = Math.floor((totalBase * descuento) / 100);
        var total = totalBase - rebaja;
        return { unidades: unidades, base: totalBase, total: total, unidad: Math.floor(total / unidades), ahorro: rebaja };
      }

      function pintar() {
        var activa = seleccionada();
        cada(tarjetas, function (tarjeta) {
          var datos = calcular(tarjeta);
          tarjeta.classList.toggle('yume-pack--seleccionado', tarjeta === activa);
          var total = tarjeta.querySelector('[data-total]');
          var base = tarjeta.querySelector('[data-base]');
          var unidad = tarjeta.querySelector('[data-unidad]');
          var ahorro = tarjeta.querySelector('[data-ahorro]');
          if (total) total.textContent = formatearDinero(datos.total, formato);
          if (base) base.textContent = formatearDinero(datos.base, formato);
          if (unidad) unidad.textContent = formatearDinero(datos.unidad, formato) + (raiz.getAttribute('data-texto-unidad') || '');
          if (ahorro) ahorro.textContent = (raiz.getAttribute('data-texto-ahorro') || '').replace('[[valor]]', formatearDinero(datos.ahorro, formato));
        });
        if (!activa || !textoBoton) return;
        if (!disponible) {
          textoBoton.textContent = raiz.getAttribute('data-texto-agotado');
          boton.disabled = true;
          return;
        }
        boton.disabled = false;
        textoBoton.textContent = (raiz.getAttribute('data-texto-boton') || '').replace('[[precio]]', formatearDinero(calcular(activa).total, formato));
      }

      cada(tarjetas, function (tarjeta) {
        var radio = tarjeta.querySelector('input[type="radio"]');
        if (!radio) return;
        radio.addEventListener('change', function () {
          pintar();
          var datos = calcular(tarjeta);
          registrar('yume_select_pack', varianteActual(raiz), datos.unidades, datos.total / datos.unidades, raiz);
        });
      });

      if (boton) {
        boton.addEventListener('click', function () {
          var activa = seleccionada();
          if (!activa || boton.disabled) return;
          var datos = calcular(activa);
          var variante = varianteActual(raiz);
          if (!variante) {
            var formulario = document.querySelector('form[id^="product-form-"]');
            if (formulario) formulario.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          if (error) {
            error.hidden = true;
            error.textContent = '';
          }
          if (raiz.getAttribute('data-accion') === 'checkout') {
            registrar('yume_initiate_checkout', variante, datos.unidades, datos.total / datos.unidades, raiz);
            window.location.href = ((window.routes && window.routes.cart_url) || '/cart') + '/' + variante + ':' + datos.unidades;
            return;
          }
          boton.disabled = true;
          boton.setAttribute('aria-busy', 'true');
          var textoPrevio = textoBoton.textContent;
          textoBoton.textContent = raiz.getAttribute('data-texto-cargando') || textoPrevio;
          anadirAlCarrito(variante, datos.unidades, 'yume-packs')
            .then(function (estado) {
              if (estado && estado.status) {
                if (error) {
                  error.textContent = estado.description || estado.message || '';
                  error.hidden = false;
                }
                return;
              }
              registrar('yume_add_to_cart', variante, datos.unidades, datos.total / datos.unidades, raiz);
            })
            .catch(function () {
              if (error) {
                error.textContent = raiz.getAttribute('data-texto-agotado') || '';
                error.hidden = false;
              }
            })
            .then(function () {
              boton.removeAttribute('aria-busy');
              boton.disabled = false;
              pintar();
            });
        });
      }

      raiz._yumeVariante = function (variante) {
        if (!variante) {
          disponible = false;
        } else {
          disponible = !!variante.available;
          raiz.setAttribute('data-precio-base', variante.price);
          raiz.setAttribute('data-variante', variante.id);
        }
        pintar();
      };

      pintar();
    }

    function iniciarEnvio(raiz) {
      var minimo = Number(raiz.getAttribute('data-min')) || 1;
      var maximo = Math.max(minimo, Number(raiz.getAttribute('data-max')) || minimo);
      var laborables = raiz.getAttribute('data-laborables') === 'true';
      var idioma = raiz.getAttribute('data-idioma') || document.documentElement.lang || 'es-ES';
      var plantilla = raiz.getAttribute('data-plantilla') || '';
      var destino = raiz.querySelector('[data-texto]');
      if (!destino || !plantilla) return;
      function sumar(dias) {
        var fecha = new Date();
        var sumados = 0;
        while (sumados < dias) {
          fecha.setDate(fecha.getDate() + 1);
          var dia = fecha.getDay();
          if (!laborables || (dia !== 0 && dia !== 6)) sumados += 1;
        }
        return fecha;
      }
      var opciones = { weekday: 'short', day: 'numeric', month: 'short' };
      var formateador;
      try {
        formateador = new Intl.DateTimeFormat(idioma, opciones);
      } catch (e) {
        formateador = new Intl.DateTimeFormat('es-ES', opciones);
      }
      var texto = plantilla
        .replace('[[fecha_min]]', '<b>' + formateador.format(sumar(minimo)) + '</b>')
        .replace('[[fecha_max]]', '<b>' + formateador.format(sumar(maximo)) + '</b>');
      var temporal = document.createElement('div');
      temporal.textContent = texto;
      destino.innerHTML = temporal.innerHTML.replace(/&lt;b&gt;/g, '<b>').replace(/&lt;\/b&gt;/g, '</b>');
    }

    function iniciarDesplegables(raiz) {
      if (raiz.getAttribute('data-unica') !== 'true') return;
      var detalles = raiz.querySelectorAll('details');
      cada(detalles, function (detalle) {
        detalle.addEventListener('toggle', function () {
          if (!detalle.open) return;
          cada(detalles, function (otro) {
            if (otro !== detalle && otro.open) otro.open = false;
          });
        });
      });
    }

    function iniciarMiniaturas(contenedor) {
      cada(contenedor.querySelectorAll('product-info .thumbnail-list'), function (lista) {
        if (lista.getAttribute('data-yume-listo') === 'true') return;
        lista.setAttribute('data-yume-listo', 'true');
        function centrar(miniatura) {
          if (!miniatura) return;
          var objetivo = miniatura.closest('.thumbnail-list__item') || miniatura;
          var izquierda = objetivo.offsetLeft - (lista.clientWidth - objetivo.offsetWidth) / 2;
          lista.scrollTo({ left: Math.max(0, izquierda), behavior: 'smooth' });
        }
        lista.addEventListener('click', function (evento) {
          var miniatura = evento.target.closest('.thumbnail');
          if (miniatura) window.requestAnimationFrame(function () { centrar(miniatura); });
        });
        if ('MutationObserver' in window) {
          new MutationObserver(function () {
            centrar(lista.querySelector('.thumbnail[aria-current]'));
          }).observe(lista, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
        }
      });
    }

    function iniciar(contenedor) {
      cada(contenedor.querySelectorAll('[data-yume-packs]'), iniciarPacks);
      cada(contenedor.querySelectorAll('[data-yume-envio]'), iniciarEnvio);
      cada(contenedor.querySelectorAll('[data-yume-desplegables]'), function (raiz) {
        if (raiz.getAttribute('data-yume-listo') === 'true') return;
        raiz.setAttribute('data-yume-listo', 'true');
        iniciarDesplegables(raiz);
      });
      iniciarMiniaturas(contenedor);
    }

    var suscrito = false;
    function suscribir() {
      if (suscrito || typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;
      suscrito = true;
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (evento) {
        var variante = evento && evento.data ? evento.data.variant : null;
        actualizarPrecios(variante);
        cada(document.querySelectorAll('[data-yume-packs]'), function (raiz) {
          if (typeof raiz._yumeVariante === 'function') raiz._yumeVariante(variante);
        });
      });
    }

    function arrancar() {
      iniciar(document);
      suscribir();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arrancar);
    } else {
      arrancar();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciar(evento.target);
      suscribir();
    });

    document.addEventListener('shopify:block:select', function (evento) {
      var detalle = evento.target && evento.target.closest ? evento.target.closest('details') : null;
      if (detalle) detalle.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main"]) return;
  try {
    
  (function () {
    var MONTO = '{' + '{amount}' + '}';

    function cada(lista, accion) {
      Array.prototype.forEach.call(lista, accion);
    }

    function formatearDinero(centimos, formato) {
      var valor = Math.round(Number(centimos) || 0);
      var plantilla = formato || MONTO;
      var patron = /\{\{\s*(\w+)\s*\}\}/;
      function separar(numero, decimales, miles, coma) {
        var fijo = (numero / 100).toFixed(decimales);
        var partes = fijo.split('.');
        var enteros = partes[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + miles);
        return partes[1] ? enteros + coma + partes[1] : enteros;
      }
      var coincidencia = plantilla.match(patron);
      var tipo = coincidencia ? coincidencia[1] : 'amount';
      var texto;
      switch (tipo) {
        case 'amount_no_decimals':
          texto = separar(valor, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          texto = separar(valor, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          texto = separar(valor, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          texto = separar(valor, 2, "'", '.');
          break;
        case 'amount_with_space_separator':
          texto = separar(valor, 2, ' ', ',');
          break;
        default:
          texto = separar(valor, 2, ',', '.');
      }
      return plantilla.replace(patron, texto);
    }

    function formatoTienda(raiz) {
      var con = raiz && raiz.closest ? raiz.closest('[data-formato-dinero]') : null;
      if (!con) con = document.querySelector('[data-formato-dinero]');
      return con ? con.getAttribute('data-formato-dinero') : MONTO;
    }

    function varianteActual(raiz) {
      var info = raiz.closest('product-info') || document;
      var entrada = info.querySelector('form[id^="product-form-"] input[name="id"]');
      if (entrada && entrada.value) return Number(entrada.value);
      var packs = raiz.getAttribute('data-variante');
      return packs ? Number(packs) : null;
    }

    function registrar(evento, variante, cantidad, precio, raiz) {
      if (!raiz || raiz.getAttribute('data-yume-tracking') !== 'true') return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: evento,
        variant_id: variante,
        quantity: cantidad,
        value: (precio * cantidad) / 100,
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      });
    }

    function anadirAlCarrito(variante, cantidad, origen) {
      var carrito = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var rutas = window.routes || {};
      var urlAnadir = rutas.cart_add_url || '/cart/add';
      var configuracion = typeof window.fetchConfig === 'function'
        ? window.fetchConfig('javascript')
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
      var cuerpo = { items: [{ id: variante, quantity: cantidad }] };
      if (carrito && typeof carrito.getSectionsToRender === 'function') {
        cuerpo.sections = carrito.getSectionsToRender().map(function (seccion) { return seccion.id; });
        cuerpo.sections_url = window.location.pathname;
      }
      configuracion.body = JSON.stringify(cuerpo);
      return fetch(urlAnadir, configuracion)
        .then(function (respuesta) { return respuesta.json(); })
        .then(function (estado) {
          if (estado.status) {
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartError, {
                source: origen,
                productVariantId: variante,
                errors: estado.errors || estado.description,
                message: estado.message
              });
            }
            return estado;
          }
          if (!carrito) {
            window.location.href = rutas.cart_url || '/cart';
            return estado;
          }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: origen, productVariantId: variante, cartData: estado });
          }
          carrito.renderContents(estado);
          carrito.classList.remove('is-empty');
          var interior = carrito.querySelector('.drawer__inner');
          if (interior) interior.classList.remove('is-empty');
          return estado;
        });
    }

    function actualizarPrecios(variante) {
      cada(document.querySelectorAll('[data-yume-precio]'), function (raiz) {
        var precio = raiz.querySelector('[data-precio]');
        var anterior = raiz.querySelector('[data-anterior]');
        var ahorro = raiz.querySelector('[data-ahorro]');
        var uso = raiz.querySelector('[data-uso]');
        var formato = formatoTienda(raiz);
        if (!variante) return;
        if (precio) precio.textContent = formatearDinero(variante.price, formato);
        var hay = variante.compare_at_price && variante.compare_at_price > variante.price;
        if (anterior) {
          anterior.hidden = !hay;
          if (hay) anterior.textContent = formatearDinero(variante.compare_at_price, formato);
        }
        if (ahorro) {
          ahorro.hidden = !hay || !raiz.getAttribute('data-texto-ahorro');
          if (hay) {
            var diferencia = variante.compare_at_price - variante.price;
            var valor = raiz.getAttribute('data-formato') === 'importe'
              ? formatearDinero(diferencia, formato)
              : Math.floor((diferencia * 100) / variante.compare_at_price) + '%';
            ahorro.textContent = (raiz.getAttribute('data-texto-ahorro') || '').replace('[[valor]]', valor);
          }
        }
        var usos = Number(raiz.getAttribute('data-usos')) || 0;
        if (uso && usos > 0) {
          uso.textContent = (raiz.getAttribute('data-texto-uso') || '').replace('[[valor]]', formatearDinero(Math.floor(variante.price / usos), formato));
        }
      });
    }

    function iniciarPacks(raiz) {
      if (raiz.getAttribute('data-yume-listo') === 'true') return;
      raiz.setAttribute('data-yume-listo', 'true');
      var tarjetas = raiz.querySelectorAll('[data-yume-pack]');
      var boton = raiz.querySelector('[data-yume-packs-boton]');
      var textoBoton = raiz.querySelector('[data-texto]');
      var error = raiz.querySelector('[data-error]');
      var formato = formatoTienda(raiz);
      var disponible = raiz.getAttribute('data-disponible') === 'true';

      function seleccionada() {
        var activa = null;
        cada(tarjetas, function (tarjeta) {
          var radio = tarjeta.querySelector('input[type="radio"]');
          if (radio && radio.checked) activa = tarjeta;
        });
        return activa || tarjetas[0];
      }

      function calcular(tarjeta) {
        var base = Number(raiz.getAttribute('data-precio-base')) || 0;
        var unidades = Number(tarjeta.getAttribute('data-unidades')) || 1;
        var descuento = Number(tarjeta.getAttribute('data-descuento')) || 0;
        var totalBase = base * unidades;
        var rebaja = Math.floor((totalBase * descuento) / 100);
        var total = totalBase - rebaja;
        return { unidades: unidades, base: totalBase, total: total, unidad: Math.floor(total / unidades), ahorro: rebaja };
      }

      function pintar() {
        var activa = seleccionada();
        cada(tarjetas, function (tarjeta) {
          var datos = calcular(tarjeta);
          tarjeta.classList.toggle('yume-pack--seleccionado', tarjeta === activa);
          var total = tarjeta.querySelector('[data-total]');
          var base = tarjeta.querySelector('[data-base]');
          var unidad = tarjeta.querySelector('[data-unidad]');
          var ahorro = tarjeta.querySelector('[data-ahorro]');
          if (total) total.textContent = formatearDinero(datos.total, formato);
          if (base) base.textContent = formatearDinero(datos.base, formato);
          if (unidad) unidad.textContent = formatearDinero(datos.unidad, formato) + (raiz.getAttribute('data-texto-unidad') || '');
          if (ahorro) ahorro.textContent = (raiz.getAttribute('data-texto-ahorro') || '').replace('[[valor]]', formatearDinero(datos.ahorro, formato));
        });
        if (!activa || !textoBoton) return;
        if (!disponible) {
          textoBoton.textContent = raiz.getAttribute('data-texto-agotado');
          boton.disabled = true;
          return;
        }
        boton.disabled = false;
        textoBoton.textContent = (raiz.getAttribute('data-texto-boton') || '').replace('[[precio]]', formatearDinero(calcular(activa).total, formato));
      }

      cada(tarjetas, function (tarjeta) {
        var radio = tarjeta.querySelector('input[type="radio"]');
        if (!radio) return;
        radio.addEventListener('change', function () {
          pintar();
          var datos = calcular(tarjeta);
          registrar('yume_select_pack', varianteActual(raiz), datos.unidades, datos.total / datos.unidades, raiz);
        });
      });

      if (boton) {
        boton.addEventListener('click', function () {
          var activa = seleccionada();
          if (!activa || boton.disabled) return;
          var datos = calcular(activa);
          var variante = varianteActual(raiz);
          if (!variante) {
            var formulario = document.querySelector('form[id^="product-form-"]');
            if (formulario) formulario.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          if (error) {
            error.hidden = true;
            error.textContent = '';
          }
          if (raiz.getAttribute('data-accion') === 'checkout') {
            registrar('yume_initiate_checkout', variante, datos.unidades, datos.total / datos.unidades, raiz);
            window.location.href = ((window.routes && window.routes.cart_url) || '/cart') + '/' + variante + ':' + datos.unidades;
            return;
          }
          boton.disabled = true;
          boton.setAttribute('aria-busy', 'true');
          var textoPrevio = textoBoton.textContent;
          textoBoton.textContent = raiz.getAttribute('data-texto-cargando') || textoPrevio;
          anadirAlCarrito(variante, datos.unidades, 'yume-packs')
            .then(function (estado) {
              if (estado && estado.status) {
                if (error) {
                  error.textContent = estado.description || estado.message || '';
                  error.hidden = false;
                }
                return;
              }
              registrar('yume_add_to_cart', variante, datos.unidades, datos.total / datos.unidades, raiz);
            })
            .catch(function () {
              if (error) {
                error.textContent = raiz.getAttribute('data-texto-agotado') || '';
                error.hidden = false;
              }
            })
            .then(function () {
              boton.removeAttribute('aria-busy');
              boton.disabled = false;
              pintar();
            });
        });
      }

      raiz._yumeVariante = function (variante) {
        if (!variante) {
          disponible = false;
        } else {
          disponible = !!variante.available;
          raiz.setAttribute('data-precio-base', variante.price);
          raiz.setAttribute('data-variante', variante.id);
        }
        pintar();
      };

      pintar();
    }

    function iniciarEnvio(raiz) {
      var minimo = Number(raiz.getAttribute('data-min')) || 1;
      var maximo = Math.max(minimo, Number(raiz.getAttribute('data-max')) || minimo);
      var laborables = raiz.getAttribute('data-laborables') === 'true';
      var idioma = raiz.getAttribute('data-idioma') || document.documentElement.lang || 'es-ES';
      var plantilla = raiz.getAttribute('data-plantilla') || '';
      var destino = raiz.querySelector('[data-texto]');
      if (!destino || !plantilla) return;
      function sumar(dias) {
        var fecha = new Date();
        var sumados = 0;
        while (sumados < dias) {
          fecha.setDate(fecha.getDate() + 1);
          var dia = fecha.getDay();
          if (!laborables || (dia !== 0 && dia !== 6)) sumados += 1;
        }
        return fecha;
      }
      var opciones = { weekday: 'short', day: 'numeric', month: 'short' };
      var formateador;
      try {
        formateador = new Intl.DateTimeFormat(idioma, opciones);
      } catch (e) {
        formateador = new Intl.DateTimeFormat('es-ES', opciones);
      }
      var texto = plantilla
        .replace('[[fecha_min]]', '<b>' + formateador.format(sumar(minimo)) + '</b>')
        .replace('[[fecha_max]]', '<b>' + formateador.format(sumar(maximo)) + '</b>');
      var temporal = document.createElement('div');
      temporal.textContent = texto;
      destino.innerHTML = temporal.innerHTML.replace(/&lt;b&gt;/g, '<b>').replace(/&lt;\/b&gt;/g, '</b>');
    }

    function iniciarDesplegables(raiz) {
      if (raiz.getAttribute('data-unica') !== 'true') return;
      var detalles = raiz.querySelectorAll('details');
      cada(detalles, function (detalle) {
        detalle.addEventListener('toggle', function () {
          if (!detalle.open) return;
          cada(detalles, function (otro) {
            if (otro !== detalle && otro.open) otro.open = false;
          });
        });
      });
    }

    function iniciarMiniaturas(contenedor) {
      cada(contenedor.querySelectorAll('product-info .thumbnail-list'), function (lista) {
        if (lista.getAttribute('data-yume-listo') === 'true') return;
        lista.setAttribute('data-yume-listo', 'true');
        function centrar(miniatura) {
          if (!miniatura) return;
          var objetivo = miniatura.closest('.thumbnail-list__item') || miniatura;
          var izquierda = objetivo.offsetLeft - (lista.clientWidth - objetivo.offsetWidth) / 2;
          lista.scrollTo({ left: Math.max(0, izquierda), behavior: 'smooth' });
        }
        lista.addEventListener('click', function (evento) {
          var miniatura = evento.target.closest('.thumbnail');
          if (miniatura) window.requestAnimationFrame(function () { centrar(miniatura); });
        });
        if ('MutationObserver' in window) {
          new MutationObserver(function () {
            centrar(lista.querySelector('.thumbnail[aria-current]'));
          }).observe(lista, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
        }
      });
    }

    function iniciar(contenedor) {
      cada(contenedor.querySelectorAll('[data-yume-packs]'), iniciarPacks);
      cada(contenedor.querySelectorAll('[data-yume-envio]'), iniciarEnvio);
      cada(contenedor.querySelectorAll('[data-yume-desplegables]'), function (raiz) {
        if (raiz.getAttribute('data-yume-listo') === 'true') return;
        raiz.setAttribute('data-yume-listo', 'true');
        iniciarDesplegables(raiz);
      });
      iniciarMiniaturas(contenedor);
    }

    var suscrito = false;
    function suscribir() {
      if (suscrito || typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;
      suscrito = true;
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (evento) {
        var variante = evento && evento.data ? evento.data.variant : null;
        actualizarPrecios(variante);
        cada(document.querySelectorAll('[data-yume-packs]'), function (raiz) {
          if (typeof raiz._yumeVariante === 'function') raiz._yumeVariante(variante);
        });
      });
    }

    function arrancar() {
      iniciar(document);
      suscribir();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arrancar);
    } else {
      arrancar();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciar(evento.target);
      suscribir();
    });

    document.addEventListener('shopify:block:select', function (evento) {
      var detalle = evento.target && evento.target.closest ? evento.target.closest('details') : null;
      if (detalle) detalle.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
